import React from 'react';
import GenericDialog from "@common/GenericDialog";

const ClassRollDialog = ({ isOpen, onClose, dialog, selectedClass, dialogTypes }) => {
    const allClasses = dialog?.type === dialogTypes?.printAllClasses;

    const handlePDF = () => {
        return new Promise(resolve => {
            printClasses('pdf', selectedClass ? selectedClass.classId : undefined);
            onClose();
            resolve();
        });
    };

    const handleExcel = () => {
        return new Promise(resolve => {
            printClasses('xlsx', selectedClass ? selectedClass.classId : undefined);
            onClose();
            resolve();
        });
    };


    function printClasses(format, classId) {
        // Use appropriate endpoint based on whether classId is provided
        const endpoint = classId !== undefined
            ? `/web/ui/user/print/printStudents.${format}?classId=${classId}`
            : `/web/ui/user/print/printAllClasses.${format}`;
        const printWindow = window.open(endpoint, 'studentListReport');
        printWindow.focus();
    }

    const title = allClasses ? 'Print All Classes' : 'Print Class';

    return (
        <GenericDialog
            title={title}
            open={isOpen}
            dialogWidth={500}
            onClose={onClose}
            buttons={[
                {
                    name: 'PDF',
                    callback: handlePDF
                },
                {
                    name: 'Excel',
                    callback: handleExcel
                },
                {
                    name: 'Cancel',
                    extraProps: { type: 'text' },
                    onClick: onClose
                }
            ]}
        >
            Please choose the export format, either PDF or Excel.
        </GenericDialog>
    );
};

export default ClassRollDialog;